import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import GlDialog from '../../../../share/dialog/GlDialog'
import GlDialogTitle from '../../../../share/dialog/GlDialogTitle'
import GlDialogBody from '../../../../share/dialog/GlDialogBody'

const ButtonStyle = styled.button`
  width: 280px;
  height: 36px;
  text-align: center;
  font-family: Fira Sans, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  background-color: ${({ isPrimary }: { isPrimary: boolean }) =>
    isPrimary ? '#252525' : '#2525251a'};
  color: ${({ isPrimary }: { isPrimary: boolean }) =>
    isPrimary ? 'white' : '#3B3B3B'};

  :disabled {
    background-color: #e9e9e9;
    color: #929292;
  }
`

const ValidationDeleteOuputDialogReadershipProfile = ({
  open,
  handleCloseDialog,
  handleAnalyticsDeleteValidation,
}: {
  open: boolean
  handleCloseDialog: () => void
  handleAnalyticsDeleteValidation: () => void
}) => {
  const { t } = useTranslation()

  const onClickCancelButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    handleCloseDialog()
  }
  const onClickContinueButton = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
    handleAnalyticsDeleteValidation()
  }

  return (
    <GlDialog open={open} onClose={handleCloseDialog}>
      <div className="flex flex-col gap-4 w-[612px]">
        <GlDialogTitle label={t('deleteModule')} />
        <GlDialogBody>
          <div className="flex flex-col text-center py-4">
            <div>{t('ConfirmDeleteModule')}</div>
          </div>
        </GlDialogBody>
        <div className="flex flex-row items-center justify-center gap-4">
          <ButtonStyle
            type="button"
            isPrimary={false}
            className="rounded"
            onClick={onClickCancelButton}
          >
            {t('commons.buttons.cancel')}
          </ButtonStyle>
          <ButtonStyle
            type="button"
            isPrimary
            className="relative rounded"
            onClick={onClickContinueButton}
          >
            {t('commons.buttons.delete')}
          </ButtonStyle>
        </div>
      </div>
    </GlDialog>
  )
}

export default ValidationDeleteOuputDialogReadershipProfile
